var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Create'),_c('List',{staticClass:"my-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }